<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
        v-if="$canEdit"
        size="small"
        >添加</el-button
      >
      <el-input
        class="filter-item"
        v-model="listQuery.app_id"
        placeholder="请输入App ID"
        clearable
        style="width: 220px"
        size="small"
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="启用" :value="'enable'" />
        <el-option label="禁用" :value="'disable'" />
        <el-option label="错误禁用" :value="'error_disable'" />
      </el-select>
      <el-select
        v-model="listQuery.is_backup"
        placeholder="是否可备用"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        icon="el-icon-search"
        :loading="listLoading"
        type="primary"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="getTargetTypeTagType(scope.row.api_type)">
            {{ getTargetTypeName(scope.row.api_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="App ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_id }}
        </template>
      </el-table-column>
      <el-table-column label="Api Key" min-width="110" align="center">
        <template slot-scope="scope">
          <div v-if="visibleSecrets[scope.$index]">
            {{ scope.row.api_key }}
          </div>
          <div v-else>
            <el-button
              type="text"
              @click="openPasswordPrompt(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="绑定合作商" min-width="200" align="center">
        <template slot-scope="scope">
          <el-tag
            v-for="(item, index) in scope.row.app_clients"
            :key="index"
            effect="plain"
          >
            {{ item.name }}
          </el-tag>
          {{ scope.row.app_clients.length <= 0 ? '-' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'enable'" type="success"
            >启用</el-tag
          >
          <el-tag v-else-if="scope.row.status == 'disable'" type="warning"
            >禁用</el-tag
          >
          <el-tag v-else-if="scope.row.status == 'error_disable'" type="danger"
            >错误禁用</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            :disabled="!scope.row.remark || scope.row.remark.length <= 20"
          >
            <div style="max-width: 200px; text-align: center" slot="content">
              {{ scope.row.remark || '-' }}
            </div>
            <span class="remark-cell">
              {{
                scope.row.remark
                  ? scope.row.remark.length > 20
                    ? scope.row.remark.substring(0, 20) + '...'
                    : scope.row.remark
                  : '-'
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="是否可备用" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_backup == 1" type="success">是</el-tag>
          <el-tag v-else-if="scope.row.is_backup == 0" type="warning"
            >否</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="错误数" min-width="220" align="center">
        <template slot-scope="scope">
          {{ scope.row.error_num }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="140"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="更新时间"
        min-width="140"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.updated_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        v-if="$canEdit"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="openPasswordPrompt(scope.$index, scope.row, 'edit')"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="90px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="类型" prop="api_type">
          <el-select v-model="form.api_type">
            <el-option
              v-for="item in apiTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-alert
          v-if="form.api_type === 'ya_si_te'"
          title="雅斯特账号参数：帐号填入账号字段，密码填入密钥字段；corp_id、sys_id、tmc_id 使用 JSON 写入备注。map_type 仅在供应商确认坐标系后填写（0百度、1 WGS84、2腾讯、3高德）。"
          type="info"
          :closable="false"
          show-icon
        />
        <el-form-item :label="form.api_type === 'ya_si_te' ? '雅斯特帐号' : 'App ID'" prop="app_id">
          <el-input v-model="form.app_id" />
        </el-form-item>
        <el-form-item :label="form.api_type === 'ya_si_te' ? '雅斯特密码' : 'Api Key'" prop="api_key">
          <el-input v-model="form.api_key" :type="form.api_type === 'ya_si_te' ? 'password' : 'text'" show-password />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status">
            <el-option label="启用" :value="'enable'" />
            <el-option label="禁用" :value="'disable'" />
            <el-option label="错误禁用" :value="'error_disable'" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否可备用" prop="is_backup">
          <el-switch v-model="form.is_backup" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            :placeholder="form.api_type === 'ya_si_te' ? '{\"corp_id\":1,\"sys_id\":6001,\"tmc_id\":0}' : ''"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" type="password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import {
  fetchTargetTypes,
  getTargetTypes,
  getTargetTypeName,
  getTargetTypeTagType,
} from '@/utils/targetType'
export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 供应商类型选项
      apiTypeOptions: [],
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: '',
        img: '',
        imgArray: [],
        link_type: 0,
        link: '',
        weight: 0,
        description: '',
        is_backup: 0,
        remark: '',
      },
      rules: {
        api_type: [
          { required: true, message: '类型不能为空', trigger: 'blur' },
        ],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        app_id: [
          { required: true, message: 'App ID不能为空', trigger: 'blur' },
        ],
        api_key: [
          { required: true, message: 'Api Key不能为空', trigger: 'blur' },
        ],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
      },
      btnLoading: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      passwordAction: 'reveal', // 'reveal' | 'edit'

      show: false,
      imgBase64Data: '', // the datebase64 url of created image
    }
  },
  created() {
    fetchTargetTypes().then(() => {
      this.apiTypeOptions = getTargetTypes()
    })
    this.getList()
  },
  methods: {
    getTargetTypeTagType: getTargetTypeTagType,
    getTargetTypeName: getTargetTypeName,
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/api-account/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          this.list = response.data.data
          this.total = response.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      console.log(this.listQuery)
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: '',
        name: '',
        app_id: '',
        api_key: '',
        status: 'enable',
        remark: '',
      }
      this.btnLoading = false
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      console.log(row)

      this.resetForm()
      this.form = Object.assign(
        {},
        { ...row, is_backup: Boolean(row.is_backup) },
      )
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/api-account/store',
            method: 'post',
            data: {
              ...this.form,
              is_backup: Number(this.form.is_backup || 0),
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/api-account/delete',
            method: 'post',
            data: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },

    openPasswordPrompt(index, row, action = 'reveal') {
      this.currentRow = row
      this.currentIndex = index
      this.passwordAction = action
      this.form2.id = row.id
      this.form2.password = ''
      this.dialogVisible2 = true
    },
    confirmPassword() {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          request({
            url: '/api/backend/api-account/get-secret',
            method: 'get',
            params: this.form2,
          }).then((response) => {
            if (this.passwordAction === 'edit') {
              this.dialogVisible2 = false
              this.list[this.currentIndex].api_key = response.data.api_key
              this.handleUpdate(this.currentRow)
            } else {
              this.$set(this.visibleSecrets, this.currentIndex, true)
              this.list[this.currentIndex].api_key = response.data.api_key
              this.dialogVisible2 = false
            }
          })
        }
      })
    },
    toggleShow() {
      this.show = !this.show
    },
    cropSuccess(imgBase64Data, field) {
      console.log('-------- 裁剪成功 --------')
      let that = this
      this.imgBase64Data = imgBase64Data
      getQiniuToken().then((response) => {
        let file = base64toFile(imgBase64Data, 'tmp.png')
        let key = guid() + '.png'
        let token = response.data.token
        let baseUrl = response.data.baseUrl
        let putExtra = {}
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2,
        }
        var observable = qiniu.upload(file, key, token, putExtra, config)
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + '/' + key
            that.form.img = imgUrl
            console.log(imgUrl)
          },
        }) // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      })
    },
  },
}
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
